var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-cards"},[_c('div',{staticClass:"left"},[_c('product-slot',{attrs:{"product":_vm.product}})],1),_c('div',{staticClass:"right"},[_c('quantity-fixed',{attrs:{"amount":_vm.product.amount}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }